import {
  IBudget,
  ICompetitor,
  ICoupons,
  IPagination,
  IState,
  IUserData,
} from "./interfaces";

export default {
  setBudget(state: IState, params: IBudget): void {
    state.budget = params;
  },

  cleanBudget(state: IState): void {
    state.budget = {
      discountsActive: 0,
      generators: [],
      id: "",
      totalDiscount: 0,
      couponsActive: [],
      transferValue: 0,
      equipamentValue: 0,
      idIntegrator: 0,
      value: 0.0,
      discountMaxBrl: 0.0,
      discountMaxPercent: 0,
      consultantName: "Nome do Consultor",
      integratorName: "Nome do Integrador",
      fantasyIntegratorName: "Nome Fantasia",
      reasonIntegratorName: "Razão Social",
      amountInverters: 0,
      powerInverter: 0,
      brandInverter: "Marca do inversor",
      brandPanel: "Marda do painel",
      powerPanel: 0,
      amountPanel: 0,
      powerSystem: 0,
      typeStructure: "Estrutura",
      deliveryLocale: "Local de entrega",
      inGroup: false,
    };
  },

  setPagination(state: IState, params: IPagination): void {
    state.paginate = params;
  },

  setCoupons(state: IState, params: ICoupons): void {
    state.coupons = params;
  },

  setExistCoupon(state: IState, param: boolean): void {
    state.existCoupon = param;
  },

  setUserData(state: IState, params: IUserData): void {
    state.userData = params;
  },

  //eslint-disable-next-line
  setCouponsUndefined(state: any): void {
    state.coupons = [];
  },

  //eslint-disable-next-line
  setGenerators(state: any, param: any): void {
    state.generators = param;
  },

  setCodeCoupon(state: IState, param: string): void {
    state.codeCoupon = param
  },

  setCompetitor(state: IState, params: ICompetitor): void {
    state.competitor = params
  },

  setPage(state: IState, page: number): void {
    state.paginate.page = page
  },

  setTypesCoupon(state: IState, params: string[]): void {
    state.typesCoupon = params
  },

  setListCompetitor(state: IState, params: string[]): void {
    state.listCompetitor = params
  },

  setPercentage(state: IState, params: number): void {
    state.percentage = params
  },

  setWebSiteId(state: IState, id: number): void {
    state.webSiteId = id
  },
};
